import React from "react";
import "./box2.css";
import img from "../../../assets/box2.jpg";

const Box2 = () => {
  return (
    <div className="box-2-custom">
      <div className="text-container-2-custom">
        <div className="title-2-custom">Snáithe</div>
        <h2 className="bidtype-second-titles-2-custom">
          The Vanguard of Innovation
        </h2>
        <div className="text-2-custom">
          In the ever-evolving landscape of technology, industry, and
          governance, Snáithe stands as the vanguard of innovation and
          transformation. With an unwavering dedication to crafting robust
          infrastructures, we wield cutting-edge technologies to shape a
          resilient backbone for countries and communities. Our mastery extends
          to enhancing the nation's defense mechanisms, where road
          infrastructures and government sector facilities intertwine seamlessly
          to fortify the security and progress of the nation.
          <br />
          <br />
          In the realm of global business, Snáithe is the beacon of trust that
          illuminates the path toward success. As we champion the cause of
          excellence, our brands serve as benchmarks of quality, pushing the
          boundaries of what's achievable. Our portfolio extends beyond mere
          products; it encompasses experiences that redefine industries and set
          new paradigms of achievement.
          <br />
          <br />
          In the corridors of government, Snáithe's name echoes as a synonym for
          reliability. We collaborate closely with government agencies,
          parliamentary members, and authoritative departments to engineer
          solutions that streamline operations, enhance efficiency, and ensure
          the nation's prosperity.
        </div>
         
        </div>
      <div className="image-container-right-1-2-custom">
        <img src={img} alt="Square Image" />
      </div>
    </div>
  );
};

export default Box2;
